import React from "react";
import { FiTwitter, FiLinkedin, FiFacebook, FiLink } from "react-icons/fi";
import { toast } from 'react-toastify';

export default function ShareButtons({ url, title, description }) {
  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    toast.success('Link copied to clipboard!');
  };

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
  };

  return (
    <div className="flex items-center gap-4 py-6 border-y border-stroke my-8">
      <span className="text-14 text-light-gray font-medium">Share:</span>
      <div className="flex items-center gap-3">
        <a
          href={shareLinks.twitter}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 h-10 rounded-full bg-light-gray/10 text-secondary hover:bg-[#1DA1F2] hover:text-white transition-all"
          aria-label="Share on Twitter"
        >
          <FiTwitter className="w-5 h-5" />
        </a>
        <a
          href={shareLinks.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 h-10 rounded-full bg-light-gray/10 text-secondary hover:bg-[#0A66C2] hover:text-white transition-all"
          aria-label="Share on LinkedIn"
        >
          <FiLinkedin className="w-5 h-5" />
        </a>
        <a
          href={shareLinks.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 h-10 rounded-full bg-light-gray/10 text-secondary hover:bg-[#1877F2] hover:text-white transition-all"
          aria-label="Share on Facebook"
        >
          <FiFacebook className="w-5 h-5" />
        </a>
        <button
          onClick={handleCopyLink}
          className="flex items-center justify-center w-10 h-10 rounded-full bg-light-gray/10 text-secondary hover:bg-primary hover:text-white transition-all"
          aria-label="Copy link"
        >
          <FiLink className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
